import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { MarkItViewApi } from '../Apis/Apis';
import KnowRiskLogo from '../Assets/KnowRisk_Dark.svg';
import StoneXLogo from '../Assets/StoneX_Dark.svg';
import Footer from './MainContainer/Footer';

export default function UserDisabledPage() {
  
  const navigate = useNavigate();

  useEffect(() => {
    MarkItViewApi.marketViewUserAuthorizationCallback(undefined).then((res) => {
      if (res.data.user?.isDisabled) {
        // User is disabled, do nothing
      } else {
        // User is not disabled, redirect to home page
        navigate('/');
      }
    });
  },[]);

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', background: 'linear-gradient(to bottom, #f8f9fa 0%,rgb(217, 217, 217) 100%)' }}>
      <div style={{ 
        display: 'flex', 
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '50px',
          alignItems: 'center'
        }}>
          {/* Top section with logo and button */}
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '30px',
            width: '100%'
            }}>
              
            <img src={StoneXLogo} alt="StoneX Logo" style={{ maxWidth: '300px' }} />
            <img src={KnowRiskLogo} alt="KnowRisk Logo" style={{ maxWidth: '250px', marginTop: '10px' }} />
            </div>

            {/* Disabled account message */}
            <div style={{ textAlign: 'center', color: 'var(--dark-red)', width: '100%', marginTop: '30px' }}>
              <h2>Your account is disabled</h2>
              <p style={{textAlign: 'center'}}>
                Your access to Know-Risk has been disabled.<br />
                Please contact us at <a href="mailto:dg-knowrisk@stonex.com">DG-KnowRisk@stonex.com</a> for assistance.
              </p>
            </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
